const spinShrink = (duration) => ({
  duration,
  rotation: 60,
  scale: 0,
  opacity: 0,
  transformOrigin: '60% 60%',
});

export default spinShrink;